import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/invitation/view/invitation.view.query.gql"
import type {
  InvitationViewQuery,
  InvitationViewQueryVariables,
} from "@/v2-backoffice-client/invitation/view/__types__/invitation.view.query"

type Options = QueryHookOptions<
  InvitationViewQuery,
  InvitationViewQueryVariables
>

export function useInvitationViewQuery(options?: Options) {
  return useQuery<InvitationViewQuery, InvitationViewQueryVariables>(
    query,
    options,
  )
}
